import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { getAwaitingInputRoute } from "../../features/hitl/presentPlan";
import { useHitlEnabled } from "../../hooks/useHitlEnabled";

interface ReviewPlanRouteGuardProps {
  children: React.ReactNode;
}

export function ReviewPlanRouteGuard({
  children,
}: ReviewPlanRouteGuardProps) {
  const { reportID } = useParams<{ reportID?: string }>();
  const hitlEnabled = useHitlEnabled();

  if (!reportID) {
    return <Navigate to="/" replace />;
  }

  if (!hitlEnabled) {
    return <Navigate to={getAwaitingInputRoute(reportID, false)} replace />;
  }

  return <>{children}</>;
}
